import { Grid } from '@mui/material';

import { HexColor } from '@nx-smartmonkey/shared/domain';
import { RoutalColorPicker } from '@nx-smartmonkey/ui';
import { RightPanelHeader } from '../../../../../components/right-panel-info/RightPanel.styled';
import { Supervisor as SupervisorDomain } from '../../../../../domain/supervisor/Supervisor';
import { useUpdateSupervisor } from '../../../../../hooks/supervisor/useUpdateSupervisor';

type SupervisorHeaderProps = {
  supervisor: SupervisorDomain;
  onClose: (...args: any[]) => any;
  options?: React.ReactElement | any;
};

export const SupervisorHeader = ({ supervisor, onClose, options }: SupervisorHeaderProps) => {
  const { run: updateSupervisor } = useUpdateSupervisor();

  const handleUpdate = (label: string, val: any) => {
    updateSupervisor({ supervisor, changes: { [label]: val } });
  };

  if (supervisor) {
    return (
      <RightPanelHeader onClose={onClose}>
        <Grid container direction="row" wrap="nowrap" alignItems="center">
          <Grid item container justifyContent="flex-start" style={{ width: `100%` }} wrap="nowrap" alignItems="center">
            <RoutalColorPicker
              color={supervisor.color?.value}
              colorSampleStyles={{
                padding: `2px 8px`,
                margin: `0 2px`,
                color: `white`,
                borderRadius: `4px`,
              }}
              onUpdate={(color: string) => {
                handleUpdate(`color`, HexColor.create(color));
              }}
            />
          </Grid>

          <Grid container direction="row" style={{ width: `auto` }} wrap="nowrap" alignItems="center">
            {options}
          </Grid>
        </Grid>
      </RightPanelHeader>
    );
  }
  return null;
};
